module.exports = __webpack_public_path__ + "images/ExternalPromo/weebly-378863-160_600.gif?dc70e";